import axios from 'axios';
import { getAuth } from '../providers/AppAuthProvider';
import { API_BASE_URL as baseUrl } from 'src/utils/api-url';

const resource = 'xpx-perps/withdrawal';

async function authHeaders() {
  const { accessToken } = (await getAuth()) || {};
  return {
    Authorization: `Bearer ${accessToken}`,
    Accept: 'application/json',
  };
}

export async function listPendingWithdrawals(page: number, pageSize: number) {
  const url = `${baseUrl}/${resource}/pending?page=${page}&page_size=${pageSize}`;
  const headers = await authHeaders();
  return axios.get<any>(url, { headers });
}

export async function approveWithdrawal(
  id: string,
  adminId: string,
  signature: string,
  timestampMs: number
) {
  const url = `${baseUrl}/${resource}/${id}/approve`;
  const headers = await authHeaders();
  return axios.post<any>(url, { admin_id: adminId, signature, timestamp_ms: timestampMs }, { headers });
}

export async function rejectWithdrawal(
  id: string,
  adminId: string,
  signature: string,
  timestampMs: number,
  note?: string
) {
  const url = `${baseUrl}/${resource}/${id}/reject`;
  const headers = await authHeaders();
  return axios.post<any>(url, { admin_id: adminId, signature, timestamp_ms: timestampMs, note }, { headers });
}
